// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__16RE0","col":"Table_col__dEiem","fulfillmentStatus":"Table_fulfillmentStatus__3lRea","emailCol":"Table_emailCol__2fdvY"};